import React, { useContext, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonButton from 'component/Argon/ArgonButton';
import DataTable from 'component/Tables/SelectDataTable';

import NLCodeContext from './ContextNLCode';

import ArgonTypography from 'component/Argon/ArgonTypography';
import { FormField, PickerPolicyDate, SelectPkg } from 'component/basicForm';
import { Stack } from '@mui/material';

function LayoutNLCode() {
  const { nlcode, setNLCode, ...state } = useContext(NLCodeContext);
  useEffect(() => {
    if (nlcode?.length < 9) {
      state.setDisabled(true);
    } else {
      state.setDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nlcode]);
  return (
    <ArgonBox mt={3} mb={8}>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={9}>
          <Card sx={{ overflow: 'visible' }}>
            <ArgonBox p={2} lineHeight={1}>
              <ArgonBox>
                <ArgonTypography variant="h6" fontWeight="medium">
                  ซื้อประกันภัย
                </ArgonTypography>
                <ArgonTypography variant="button" fontWeight="regular" color="text">
                  ตามมติ 5 กรกฎาคม 2566
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox mt={3}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <PickerPolicyDate value={state.policyDate} setValue={state.setPolicyDate} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <SelectPkg value={state.pkg} setValue={state.setPkg} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Stack direction="row">
                      <FormField
                        ml={0}
                        placeholder="ระบุรหัส เช่น NL-00-00000X"
                        value={nlcode}
                        onChange={(v) => setNLCode(v.target.value)}
                      />
                      <ArgonButton
                        disabled={state.disabled}
                        variant="gradient"
                        color="success"
                        size="small"
                        onClick={state.getNLCodeList}
                        sx={{ whiteSpace: 'nowrap', ml: 1 }}
                      >
                        ตรวจสอบ
                      </ArgonButton>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={2}>
                    <Stack direction="row" justifyContent="flex-end">
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <ArgonButton size="small" variant="gradient" color="error" onClick={state.handleRemove}>
                          ลบ
                        </ArgonButton>
                        <ArgonButton size="small" variant="gradient" color="error" onClick={state.handleRemoveAll}>
                          ลบทั้งหมด
                        </ArgonButton>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </ArgonBox>
            </ArgonBox>
            <ArgonBox px={2}>
              <DataTable
                onSelected={state.handleSelected}
                table={{
                  columns: [
                    {
                      Header: 'ลำดับที่',
                      accessor: 'recordNo',
                      maxWidth: 20,
                      minWidth: 10,
                      width: 10,
                    },
                    {
                      Header: 'ชื่อ',
                      Cell: ({ row }) => {
                        const data = row.original;
                        return data?.name.concat(data?.surename ? ' ' + data?.surename : '');
                      },
                    },
                    {
                      Header: 'เลขประจำตัว',
                      Cell: ({ row }) => {
                        const data = row.original;
                        return data.idCard || data?.alcode;
                      },
                    },
                  ],
                  rows: state.parseData,
                }}
                entriesPerPage={{
                  defaultValue: 25,
                  entries: [25, 50, 100],
                }}
                canSearch
              />
            </ArgonBox>
            <ArgonBox px={2}>
              <Stack direction="row" alignItems="end" justifyContent="flex-end">
                <ArgonBox mt={2}>
                  <ArgonButton
                    disabled={state.parseData < 1}
                    variant="gradient"
                    color="success"
                    size="small"
                    onClick={state.handleSubmit}
                  >
                    ชำระเงิน
                  </ArgonButton>
                </ArgonBox>
              </Stack>
            </ArgonBox>
            <ArgonBox px={4} py={2}>
              <ArgonTypography variant="caption">
                <p>หมายเหตุ*</p>
                <p>สามารถใช้ข้อมูลอ้างอิงเพื่อซื้อประกันตามมติ 5 กรกฎาคม 2566 ได้ดังนี้</p>
                <ul>
                  <li>Name list ที่ได้จากการขึ้นทะเบียนกรมจัดหางาน</li>
                  <li>หมายเลขประจำตัวแรงงานตามที่ปรากฏในเอกสาร Name list จากกรมจัดหางาน</li>
                  <li>URL ที่ได้จากการสแกน QR ในเอกสาร Name list</li>
                </ul>
              </ArgonTypography>
            </ArgonBox>
          </Card>
        </Grid>
      </Grid>
    </ArgonBox>
  );
}

export default LayoutNLCode;
